<template>
  <FreeBottomSheet :name="name" @onClose="emit('onClose')">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h2 class="text-text-neutral-primary text-base font-medium">
            {{ $t('ancillaries.baggages.baggageWeight') }}
          </h2>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="space-y-4 px-4 pb-4 pt-2">
        <div class="space-y-2">
          <FreeRadioBlock
            v-for="(baggage, idx) in baggageList"
            :key="baggage.id"
            :checked="baggage.isSelected"
            :qa-id="`baggage.optionsList.option.${idx}.radio`"
            name="baggageSelect"
            @onChange="emit('onBaggageChange', baggage.id)"
          >
            <template #title>
              <div class="space-y-0.5">
                <p class="text-text-neutral-primary text-base font-semibold">
                  {{ baggage.title }}
                </p>
                <p class="text-text-positive-primary text-xs font-medium">
                  <span v-price="baggage.price.amount"></span>
                  <span
                    v-if="
                      mappedPassengersLib.hasBaggageDiscount(baggage) &&
                      mappedPassengersLib.getBaggageOriginalPrice(baggage)
                    "
                    v-price="
                      mappedPassengersLib.getBaggageOriginalPrice(baggage)
                    "
                    class="text-text-neutral-quaternary ml-1 line-through"
                  ></span>
                </p>
              </div>
            </template>
          </FreeRadioBlock>
        </div>
        <FreeButton
          type="button"
          class="green-main-button sticky bottom-4 w-full"
          @click="emit('onBaggageSave')"
        >
          {{ $t('general.save') }}
        </FreeButton>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import {
    FreeBottomSheet,
    FreeHeader,
    FreeCloseButton,
    FreeButton,
    FreeRadioBlock,
  } from 'freedom-shared';

  import { mappedPassengersLib } from '@/entities/passenger-with-baggages';
  import type { ExtendedBaggage } from '@/entities/passenger-with-baggages';

  defineProps<{
    name: string;
    baggageList: ExtendedBaggage[];
    flightDirection: string;
    totalPrice: number;
  }>();

  const emit = defineEmits<{
    onBaggageSave: [];
    onClose: [];
    onBaggageChange: [id: string];
  }>();
</script>
